/* GENERATED FILE — DO NOT EDIT.
 * Source: rules.json -> measurementSchema (groups, fields).
 * Regenerate: npm run measurement-schema:build
 *
 * Presentation facts only: the tailor's field order, the group each field
 * belongs to, its unit and its permitted range. No constraint, no price, no
 * lead time, and nothing evaluative — the server owns every rule outcome.
 */

export interface MeasurementGroup {
  readonly id: string;
}

export interface MeasurementField {
  readonly id: string;
  readonly group: string;
  readonly type: 'number' | 'enum' | 'text';
  readonly unit: string | null;
  readonly min: number | null;
  readonly max: number | null;
  readonly required: boolean;
  readonly values: readonly string[] | null;
}

export const MEASUREMENT_GROUPS: readonly MeasurementGroup[] = [
  {
    "id": "body_core"
  },
  {
    "id": "torso"
  },
  {
    "id": "arms"
  },
  {
    "id": "lower"
  },
  {
    "id": "waistcoat"
  },
  {
    "id": "posture"
  },
  {
    "id": "notes"
  }
];

export const MEASUREMENT_FIELDS: readonly MeasurementField[] = [
  {
    "id": "height",
    "group": "body_core",
    "type": "number",
    "unit": "cm",
    "min": 140,
    "max": 215,
    "required": true,
    "values": null
  },
  {
    "id": "weight_kg",
    "group": "body_core",
    "type": "number",
    "unit": "kg",
    "min": 40,
    "max": 200,
    "required": false,
    "values": null
  },
  {
    "id": "neck",
    "group": "torso",
    "type": "number",
    "unit": "cm",
    "min": 30,
    "max": 60,
    "required": true,
    "values": null
  },
  {
    "id": "chest",
    "group": "torso",
    "type": "number",
    "unit": "cm",
    "min": 70,
    "max": 160,
    "required": true,
    "values": null
  },
  {
    "id": "over_chest",
    "group": "torso",
    "type": "number",
    "unit": "cm",
    "min": 68,
    "max": 155,
    "required": true,
    "values": null
  },
  {
    "id": "natural_waist",
    "group": "torso",
    "type": "number",
    "unit": "cm",
    "min": 55,
    "max": 170,
    "required": true,
    "values": null
  },
  {
    "id": "seat",
    "group": "torso",
    "type": "number",
    "unit": "cm",
    "min": 70,
    "max": 175,
    "required": true,
    "values": null
  },
  {
    "id": "shoulder_width",
    "group": "torso",
    "type": "number",
    "unit": "cm",
    "min": 34,
    "max": 60,
    "required": true,
    "values": null
  },
  {
    "id": "back_width",
    "group": "torso",
    "type": "number",
    "unit": "cm",
    "min": 30,
    "max": 56,
    "required": true,
    "values": null
  },
  {
    "id": "front_chest_width",
    "group": "torso",
    "type": "number",
    "unit": "cm",
    "min": 26,
    "max": 54,
    "required": true,
    "values": null
  },
  {
    "id": "nape_to_waist",
    "group": "torso",
    "type": "number",
    "unit": "cm",
    "min": 34,
    "max": 56,
    "required": true,
    "values": null
  },
  {
    "id": "front_length_neck_to_waist",
    "group": "torso",
    "type": "number",
    "unit": "cm",
    "min": 34,
    "max": 60,
    "required": true,
    "values": null
  },
  {
    "id": "scye_depth",
    "group": "torso",
    "type": "number",
    "unit": "cm",
    "min": 17,
    "max": 32,
    "required": true,
    "values": null
  },
  {
    "id": "armhole_circumference",
    "group": "torso",
    "type": "number",
    "unit": "cm",
    "min": 34,
    "max": 68,
    "required": false,
    "values": null
  },
  {
    "id": "jacket_length_from_nape",
    "group": "torso",
    "type": "number",
    "unit": "cm",
    "min": 58,
    "max": 92,
    "required": true,
    "values": null
  },
  {
    "id": "half_back_left",
    "group": "torso",
    "type": "number",
    "unit": "cm",
    "min": 14,
    "max": 30,
    "required": true,
    "values": null
  },
  {
    "id": "half_back_right",
    "group": "torso",
    "type": "number",
    "unit": "cm",
    "min": 14,
    "max": 30,
    "required": true,
    "values": null
  },
  {
    "id": "sleeve_length_left",
    "group": "arms",
    "type": "number",
    "unit": "cm",
    "min": 48,
    "max": 78,
    "required": true,
    "values": null
  },
  {
    "id": "sleeve_length_right",
    "group": "arms",
    "type": "number",
    "unit": "cm",
    "min": 48,
    "max": 78,
    "required": true,
    "values": null
  },
  {
    "id": "bicep",
    "group": "arms",
    "type": "number",
    "unit": "cm",
    "min": 20,
    "max": 58,
    "required": true,
    "values": null
  },
  {
    "id": "elbow",
    "group": "arms",
    "type": "number",
    "unit": "cm",
    "min": 18,
    "max": 48,
    "required": false,
    "values": null
  },
  {
    "id": "wrist",
    "group": "arms",
    "type": "number",
    "unit": "cm",
    "min": 13,
    "max": 26,
    "required": true,
    "values": null
  },
  {
    "id": "trouser_waist",
    "group": "lower",
    "type": "number",
    "unit": "cm",
    "min": 58,
    "max": 175,
    "required": true,
    "values": null
  },
  {
    "id": "trouser_seat",
    "group": "lower",
    "type": "number",
    "unit": "cm",
    "min": 70,
    "max": 180,
    "required": true,
    "values": null
  },
  {
    "id": "body_rise_seated",
    "group": "lower",
    "type": "number",
    "unit": "cm",
    "min": 18,
    "max": 40,
    "required": true,
    "values": null
  },
  {
    "id": "front_rise",
    "group": "lower",
    "type": "number",
    "unit": "cm",
    "min": 18,
    "max": 42,
    "required": true,
    "values": null
  },
  {
    "id": "back_rise",
    "group": "lower",
    "type": "number",
    "unit": "cm",
    "min": 22,
    "max": 50,
    "required": true,
    "values": null
  },
  {
    "id": "crotch_length_total",
    "group": "lower",
    "type": "number",
    "unit": "cm",
    "min": 55,
    "max": 105,
    "required": false,
    "values": null
  },
  {
    "id": "outseam",
    "group": "lower",
    "type": "number",
    "unit": "cm",
    "min": 82,
    "max": 128,
    "required": true,
    "values": null
  },
  {
    "id": "outseam_left",
    "group": "lower",
    "type": "number",
    "unit": "cm",
    "min": 82,
    "max": 128,
    "required": false,
    "values": null
  },
  {
    "id": "outseam_right",
    "group": "lower",
    "type": "number",
    "unit": "cm",
    "min": 82,
    "max": 128,
    "required": false,
    "values": null
  },
  {
    "id": "inseam",
    "group": "lower",
    "type": "number",
    "unit": "cm",
    "min": 58,
    "max": 98,
    "required": true,
    "values": null
  },
  {
    "id": "inseam_left",
    "group": "lower",
    "type": "number",
    "unit": "cm",
    "min": 58,
    "max": 98,
    "required": false,
    "values": null
  },
  {
    "id": "inseam_right",
    "group": "lower",
    "type": "number",
    "unit": "cm",
    "min": 58,
    "max": 98,
    "required": false,
    "values": null
  },
  {
    "id": "thigh",
    "group": "lower",
    "type": "number",
    "unit": "cm",
    "min": 38,
    "max": 95,
    "required": true,
    "values": null
  },
  {
    "id": "knee",
    "group": "lower",
    "type": "number",
    "unit": "cm",
    "min": 28,
    "max": 68,
    "required": true,
    "values": null
  },
  {
    "id": "calf",
    "group": "lower",
    "type": "number",
    "unit": "cm",
    "min": 24,
    "max": 58,
    "required": false,
    "values": null
  },
  {
    "id": "ankle",
    "group": "lower",
    "type": "number",
    "unit": "cm",
    "min": 18,
    "max": 40,
    "required": true,
    "values": null
  },
  {
    "id": "instep_girth",
    "group": "lower",
    "type": "number",
    "unit": "cm",
    "min": 28,
    "max": 48,
    "required": false,
    "values": null
  },
  {
    "id": "usual_shoe_heel_cm",
    "group": "lower",
    "type": "number",
    "unit": "cm",
    "min": 0,
    "max": 6,
    "required": false,
    "values": null
  },
  {
    "id": "waistcoat_length_front",
    "group": "waistcoat",
    "type": "number",
    "unit": "cm",
    "min": 42,
    "max": 78,
    "required": false,
    "values": null
  },
  {
    "id": "waistcoat_length_back",
    "group": "waistcoat",
    "type": "number",
    "unit": "cm",
    "min": 32,
    "max": 68,
    "required": false,
    "values": null
  },
  {
    "id": "posture",
    "group": "posture",
    "type": "enum",
    "unit": null,
    "min": null,
    "max": null,
    "required": true,
    "values": [
      "erect",
      "normal",
      "stooping",
      "very_stooping"
    ]
  },
  {
    "id": "shoulder_slope_class",
    "group": "posture",
    "type": "enum",
    "unit": null,
    "min": null,
    "max": null,
    "required": true,
    "values": [
      "square",
      "normal",
      "sloping",
      "very_sloping"
    ]
  },
  {
    "id": "shoulder_slope_left_deg",
    "group": "posture",
    "type": "number",
    "unit": "deg",
    "min": 10,
    "max": 40,
    "required": false,
    "values": null
  },
  {
    "id": "shoulder_slope_right_deg",
    "group": "posture",
    "type": "number",
    "unit": "deg",
    "min": 10,
    "max": 40,
    "required": false,
    "values": null
  },
  {
    "id": "shoulder_drop_side",
    "group": "posture",
    "type": "enum",
    "unit": null,
    "min": null,
    "max": null,
    "required": true,
    "values": [
      "none",
      "left_lower",
      "right_lower"
    ]
  },
  {
    "id": "shoulder_drop_cm",
    "group": "posture",
    "type": "number",
    "unit": "cm",
    "min": 0,
    "max": 4,
    "required": false,
    "values": null
  },
  {
    "id": "hip_drop_side",
    "group": "posture",
    "type": "enum",
    "unit": null,
    "min": null,
    "max": null,
    "required": false,
    "values": [
      "none",
      "left_lower",
      "right_lower"
    ]
  },
  {
    "id": "hip_drop_cm",
    "group": "posture",
    "type": "number",
    "unit": "cm",
    "min": 0,
    "max": 5,
    "required": false,
    "values": null
  },
  {
    "id": "blade_prominence",
    "group": "posture",
    "type": "enum",
    "unit": null,
    "min": null,
    "max": null,
    "required": true,
    "values": [
      "normal",
      "prominent"
    ]
  },
  {
    "id": "chest_shape",
    "group": "posture",
    "type": "enum",
    "unit": null,
    "min": null,
    "max": null,
    "required": true,
    "values": [
      "normal",
      "full",
      "hollow"
    ]
  },
  {
    "id": "stomach_prominence",
    "group": "posture",
    "type": "enum",
    "unit": null,
    "min": null,
    "max": null,
    "required": true,
    "values": [
      "none",
      "slight",
      "moderate",
      "prominent"
    ]
  },
  {
    "id": "seat_prominence",
    "group": "posture",
    "type": "enum",
    "unit": null,
    "min": null,
    "max": null,
    "required": true,
    "values": [
      "flat",
      "normal",
      "prominent"
    ]
  },
  {
    "id": "neck_position",
    "group": "posture",
    "type": "enum",
    "unit": null,
    "min": null,
    "max": null,
    "required": true,
    "values": [
      "normal",
      "forward"
    ]
  },
  {
    "id": "arm_position",
    "group": "posture",
    "type": "enum",
    "unit": null,
    "min": null,
    "max": null,
    "required": true,
    "values": [
      "normal",
      "forward"
    ]
  },
  {
    "id": "leg_shape",
    "group": "posture",
    "type": "enum",
    "unit": null,
    "min": null,
    "max": null,
    "required": true,
    "values": [
      "straight",
      "bow",
      "knock_knee"
    ]
  },
  {
    "id": "dominant_hand",
    "group": "posture",
    "type": "enum",
    "unit": null,
    "min": null,
    "max": null,
    "required": false,
    "values": [
      "left",
      "right"
    ]
  },
  {
    "id": "not_taken",
    "group": "notes",
    "type": "text",
    "unit": null,
    "min": null,
    "max": null,
    "required": false,
    "values": null
  },
  {
    "id": "fitting_notes",
    "group": "notes",
    "type": "text",
    "unit": null,
    "min": null,
    "max": null,
    "required": false,
    "values": null
  },
  {
    "id": "corrections_applied",
    "group": "notes",
    "type": "text",
    "unit": null,
    "min": null,
    "max": null,
    "required": false,
    "values": null
  }
];

export const MEASUREMENT_FIELD_COUNT = 61;
